<template>
<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M3.33203 14.1667V15.8334C3.33203 16.7538 4.07822 17.5 4.9987 17.5H14.9987C15.9192 17.5 16.6654 16.7538 16.6654 15.8334V14.1667" stroke="#AC986A" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M5.83203 9.16669L9.9987 13.3334L14.1654 9.16669" stroke="#AC986A" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M9.9987 3.33331V13.3333" stroke="#AC986A" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
</svg>
</template>